import { Routes } from '@/plugins/router/constants'

export const routes = [
  { path: '/', redirect: Routes.Login },
  {
    path: '/',
    component: () => import('@/layouts/default.vue'),
    children: [
      {
        path: 'login',
        name: Routes.Login,
        component: () => import('@/pages/login.vue'),
      },
      {
        path: 'welcome',
        redirect: { name: Routes.Login },
      },
      {
        path: 'logout',
        name: Routes.Logout,
        component: () => import('@/pages/logout.vue'),
      },
    ],
  },
  {
    path: '/callback',
    name: Routes.Callback,
    component: () => import('@/pages/callback.vue'),
  },
  {
    path: '/silent-token',
    name: Routes.SilentToken,
    component: () => import('@/pages/silent-token.vue'),
  },
  {
    path: '/signout-callback',
    name: Routes.SignoutCallback,
    component: () => import('@/pages/signout-callback.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/pages/[...error].vue'),
  },
]
